import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import Notifications from "./Notification";
import { classNames } from "../AppNav";
import { useSelector } from "react-redux";

const NotificationNavItem = ({ menuItem, isCurrent, currentUser }) => {
  const unreadNotification = useSelector((state: any) =>
    state.layoutReducer.get("unreadNotification")
  );
  return (
    <Popover
      className={classNames(
        isCurrent
          ? "bg-gray-100 text-blue-600"
          : "text-gray-700 hover:text-blue-600 hover:bg-gray-100",
        "group flex gap-x-3 rounded-md p-1 cursor-pointer relative"
      )}
    >
      <PopoverButton as={"div"} className={"flex gap-x-3 w-full"}>
        {menuItem}
        {unreadNotification > 0 && (
          <span className="absolute top-2 right-2 w-1.5 h-1.5 bg-red-500 rounded-full"></span>
        )}
      </PopoverButton>
      <PopoverPanel anchor="right start" className="z-50 ml-1 p-2">
        <Notifications userId={currentUser.get("accountId")} />
      </PopoverPanel>
    </Popover>
  );
};

export default NotificationNavItem;
